import request from "_private/utils/request";


/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/emergencyCompanyInvitationInfo/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 获取所有企业信息
 * @param {*} data
 */
export function FetchEmergencyCompary() {
    return request({
        url: "/base/compary/findAllComparys",
        method: "post",
    });
}